module.exports = require('./dopemerge')
